import fetchApi from "../fetchApi";
export const EnableUser = async (id, offices) => {
    const options = {
        method: 'PUT',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify({
            "latest_status": "active",
            "office_ids": offices,
        }),
        redirect: 'follow'
    }

    return await fetchApi(`users/${id}`, options);
};